import * as utils from '../utils';
import { internalGetLayoutInspector } from '../contentmanagement.selectors';

export const storeLayoutEditorFormData = (state, action) => {
  const updatedRows = utils.storeLayoutEditorFormData({
    rows: state.loadedPage.cmsContent.rows,
    rowIndex: action.payload.rowIndex,
    columnIndex: action.payload.columnIndex,
    inspector: internalGetLayoutInspector(
      state.templates,
      action.payload.type,
      action.payload.type
    ),
    data: action.payload.data
  });

  // Merge rowEditorData.width into the row so Layoutwidth selection (Content/Browser width)
  // is persisted when saving fullwidth single-component layouts (e.g. CouponsGallery, PromotionsGallery)
  const rowEditorWidth = state.rowEditorData?.width;
  const rows =
    rowEditorWidth !== undefined && rowEditorWidth !== null
      ? updatedRows.map((row, i) =>
          i === action.payload.rowIndex ? { ...row, width: rowEditorWidth } : row
        )
      : updatedRows;

  return {
    ...state,
    loadedPage: {
      ...state.loadedPage,
      cmsContent: {
        ...state.loadedPage.cmsContent,
        rows
      }
    }
  };
};
